 <template>
  <div class="display-flex flex-column f1-3 h100p">
    <div class="display-flex justify-between minh7-dk pt1 pb1 pr2" :class="{ 'pos-sticky top-1 bg-white': sticky }" v-if="title || enableSearch">
      <h3 class="title ma0 pa1 f1-5 pt2" :class="titleClass" v-if="title">{{ title }}</h3>
      <bh-search-bar class="w40p-dk ma-5" v-if="enableSearch" @search="onSearch" :placeholder="searchPlaceholder" />
    </div>
    <div class="w100p scroll-x-auto minh50">
      <table class="table-container w100p">
        <thead>
          <tr>
            <th v-if="enableCheckbox" :class="getHeaderClass" class="w1">
              <bh-checkbox :disabled="isHeaderCheckboxDisabled" @output="onAllRowSelect" :checked="allSelected"/>
            </th>
            <th :class="getHeaderClass" v-for="(value, key) in getHeaders" :key="key" class="mh2">
              <bh-icon icon="play-left" class="pos-abs left0 text-violet inline" @output="onPrev()" v-if="prevEnabled && key  === keysVisible[0]"/>
              <bh-multi-select :label="value" v-if="value === 'Location'" @output="selectedLocations($event)" :options="filterList" showSelectAll emitActionButton :actionButtonLabel="'Filter'"/>
              <!-- <span class="text-center pointer" v-if="value !== 'Location'" v-on="enableSort ? { click: sort.bind(this, key) } : {}">{{ value }}</span> -->
              <span class="text-center pointer">{{ value }}</span>
              <!-- <span v-if="enableSort" class="inline-block pointer" :class="sortClass(key)" v-on="enableSort ? { click: sort.bind(this, key) } : {}"></span> -->
              <bh-icon icon="play-right" class="pr1-2 pos-abs right0 text-violet inline" @output="onNext()"  v-if="nextEnabled && key  === keysVisible[numberOfColumnsMob - 1]"/>
            </th>
          </tr>
        </thead>
        <tbody v-if="tableLength">
          <tr v-for="(row, index) in sortedRows" :key="index" :class="{'first-row-highlight ' :firstRowHighlight == true && index == 0 }"  @click="emitRow(row)" class="bg-white">
            <!-- <td v-if="enableCheckbox">
              <bh-checkbox :value="row" :disabled="row.isDisabled"  :checked="row.checked" @output="onRowSelect(row)" v-if="(row && row.active && (row.active.originalValue !== userId)) || configDeviceList"/>
            </td> -->
            <!-- <td :data-label="key" :key="data.value + key" v-for="(data, key) in getRowData(row)" class="cell text-center" :class="cellClass">
              <slot :data="data" :name="key">
                <span class="display-flex align-center justify-center">
                  <span class="display-flex justify-center" :class="data.class">
                    {{ data.value }}
                    <bh-tooltip v-if="data.tooltipContent" class="ml1 text-violet" :tooltipContent="data.tooltipContent" :tooltipPosition="'top'"/>
                  </span>
                </span>
              </slot>
            </td> -->
              <td :data-label="key" :key="data.value + key" v-for="(data, key) in getRowData(row)" class="cell text-center" :class="cellClass">
              <slot v-if="key === 'checked'">
                <bh-checkbox :value="row" :disabled="row.isDisabled"  :checked="row.checked" @output="onRowSelect(row)" v-if="(row && row.active && (row.active.originalValue !== userId)) || configDeviceList"/>
              </slot>
              <slot v-else :data="data" :name="key">
                <span class="display-flex align-center justify-center">
                  <span class="display-flex justify-center" :class="data.class">
                    {{ data.value }}
                    <bh-tooltip v-if="data.tooltipContent" class="ml1 text-violet" :tooltipContent="data.tooltipContent" :tooltipPosition="'top'"/>
                  </span>
                </span>
              </slot>
            </td>
          </tr>
          <tr v-if="spinner">
            <td colspan="100%">
              <bh-loader />
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="Object.keys(headers).length">
             <h2>No Data Available</h2>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const MOBILE_WIDTH = 728

export default {
  name: 'bh-table',
  props: {
    title: {
      type: String,
      default: ''
    },
    sticky: {
      type: Boolean,
      default: false
    },
    firstColumnAlignLeft: {
      type: Boolean,
      default: true
    },
    titleClass: {
      type: String,
      default: ''
    },
    tableLength: {
      type: Number,
      default: null
    },
    rows: {
      type: Array | Object,
      default: () => [{ id: 1, name: 'User 1', age: 20 }, { id: 2, name: 'User 2', age: 24 }]
    },
    headers: {
      type: Object,
      // exmaple input headers = [{ id: "Id", name: "Name", age: "Age" }]
      default: () => ({ id: 'Id', name: 'Name', age: 'Age' }) // table header, with keys - are data keys, values -> Header names
    },
    headerClass: {
      type: String,
      default: ''
    },
    cellClass: {
      type: String,
      default: 'justify-center'
    },
    numberOfColumnsMob: {
      type: Number,
      default: 1
    },
    stickyColMob: {
      type: String,
      default: ''
    },
    customSort: {
      type: Boolean,
      default: false
    },
    enableSort: {
      type: Boolean,
      default: true
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    enableCheckbox: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: 'Search'
    },
    spinner: {
      type: Boolean,
      default: false
    },
    firstRowHighlight: {
      type: Boolean,
      default: false
    },
    configDeviceList: {
      type: Boolean,
      default: false
    },
    isHeaderCheckboxDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false,
      currentKey: '',
      order: 'ASC',
      keysVisible: [],
      currentMobColIndex: 0,
      stickyColMobFinal: '',
      prevEnabled: false,
      nextEnabled: false,
      sortedRows: [],
      tableDataBackup: [],
      filterList: [],
      allSelected: false
    }
  },
  computed: {
    ...mapGetters('common/user', ['userId']),
    getHeaders() {
      return this.getRowData(this.headers)
    },
    getHeaderClass() {
      let headerClass = this.headerClass
      headerClass += this.sticky ? ' pos-sticky top-1 bg-white text-center' : ''
      headerClass += this.firstColumnAlignLeft ? ' firstColumnAlignLeft' : ''
      return headerClass
    }
  },
  watch: {
    rows: {
      handler() {
        this.sortedRows = JSON.parse(JSON.stringify(this.rows))
        if (this.currentKey) {
          this.sortBy({ key: this.currentKey, order: this.order })
        }
      }
    }
  },
  beforeMount() {
    this.stickyColMobFinal = this.stickyColMob || Object.keys(this.headers)[0]
    if (window && window.innerWidth <= MOBILE_WIDTH) {
      this.setColumnOptions()
    }
    this.sortedRows = JSON.parse(JSON.stringify(this.rows))
    this.tableDataBackup = this.sortedRows
    for (let index = 0; index < this.sortedRows.length; index++) {
      // const locationDetailList = this.sortedRows[index].location.value.split(' | ')
      // const locationValue = this.sortedRows[index].location.value === 'N/A' ? 'N/A' : locationDetailList[1]
      // if (locationValue && !this.filterList.find(location => location.value === locationValue)) {
      //   this.filterList.push({ label: locationValue, value: locationValue, selected: true })
      // }
    }
  },
  methods: {
    /**
     * emits clicked node
     * @method emitRow
     * @param row - { Object }
     */
    emitRow(row) {
      this.$emit('output', row)
    },
    onRowSelect(row) {
      row.checked = !row.checked
      // this.allSelected = row.checked
      this.$emit('onRowSelect', row)
    },
    onAllRowSelect() {
      this.allSelected = !this.allSelected
      this.sortedRows.forEach(user => {
        if (!user.isDisabled) {
          user.checked = this.allSelected
        }
        this.$emit('onRowSelect', user)
      })
      this.$emit('onAllRowSelect', { state: this.allSelected, rows: this.sortedRows })
    },
    /**
     * sorts by node
     * @method sort
     * @param key - { String } - data key
     */
    sort(key) {
      this.order = this.currentKey === key && this.order === 'ASC' ? 'DESC' : 'ASC'
      this.currentKey = key
      const sortParams = { key, order: this.order }
      if (this.customSort) {
        this.$emit('sort', sortParams)
      } else {
        this.sortBy(sortParams)
      }
    },
    sortClass(key) {
      let classes = this.currentKey === key ? 'active ' : ''
      classes += this.currentKey === key && this.order === 'ASC' ? 'sort-by-asc' : 'sort-by-desc'
      return classes
    },
    onSearch(input) {
      this.$emit('search', input)
    },
    /**
     * Callback for sorting
     * @method sortBy
     * @param - { Object }
    */
    sortBy({ key, order }) {
      this.sortedRows.sort((a, b) => {
        const preVal = a[key].originalValue ?? a[key].value
        const nextVal = b[key].originalValue ?? b[key].value
        if (order === 'ASC') {
          if (preVal > nextVal) return 1
          if (preVal < nextVal) return -1
        } else {
          if (preVal < nextVal) return 1
          if (preVal > nextVal) return -1
        }
        return 0
      })
    },
    setColumnOptions() {
      const headerKeys = Object.keys(this.headers)
      const minIndex = this.currentMobColIndex
      const maxIndex = this.currentMobColIndex + this.numberOfColumnsMob
      this.keysVisible = headerKeys.filter((header, index) => header !== this.stickyColMobFinal).filter((header, index) => index >= minIndex && index < maxIndex)
      this.nextEnabled = this.currentMobColIndex < (headerKeys.length - this.numberOfColumnsMob - 1)
      this.prevEnabled = this.currentMobColIndex > 0
    },
    getRowData(dataObj) {
      if (window && window.innerWidth <= MOBILE_WIDTH) {
        dataObj = JSON.parse(JSON.stringify(dataObj))
        Object.keys(dataObj).forEach(headerKey => {
          if (!this.keysVisible.includes(headerKey) && headerKey !== this.stickyColMobFinal) {
            delete dataObj[headerKey]
          }
        })
        return dataObj
      }
      return dataObj
    },
    onNext() {
      this.currentMobColIndex += this.numberOfColumnsMob
      this.setColumnOptions()
    },
    onPrev() {
      this.currentMobColIndex -= this.numberOfColumnsMob
      this.setColumnOptions()
    },
    toggleFilter() {
      this.showMenu = !this.showMenu
    },
    selectedLocations(locationList) {
      if (locationList.length === this.filterList.length) {
        this.sortedRows = [...this.tableDataBackup]
      }
      this.sortedRows = this.tableDataBackup.filter(element => locationList.find(location => element.location.value.indexOf(location.value) > -1))
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}

tbody tr:hover {
  background-color:#f0f0f0;
  cursor: pointer;
}

th {
  color: #5764B3;
  font-size: 1.4rem;
  padding: 1rem 1.5rem;
}

td {
  padding: 1.5rem;
}

tr th.firstColumnAlignLeft:nth-child(1) {
  /* text-align: left; */
  /* padding-left: 4rem; */
}

.sort-by-asc {
  left: 3px;
  width: 0;
  height: 0;
  border: solid 5px transparent;
  margin: 4px 4px 0 3px;
  background: transparent;
  border-bottom: solid 7px #d3d3d3;
  border-top-width: 0;
}

.sort-by-desc {
  left: 3px;
  width: 0;
  height: 0;
  border: solid 5px transparent;
  margin: 4px 4px 0 3px;
  background: transparent;
  border-top: solid 7px #d3d3d3;
  border-bottom-width: 0;
}

.active.sort-by-asc {
  border-bottom: solid 7px #000000;
  border-top-width: 0;
}

.active.sort-by-desc {
  border-top: solid 7px #000000;
  border-bottom-width: 0;
}

.first-row-highlight {
  background-color:#f0f0f0;
}

@media (min-width: 768px) {
  table td, table th {
    border-top: 1px solid #dddddd;
  }
}
</style>
